import { render, staticRenderFns } from "./DialogPhotoDetail.vue?vue&type=template&id=aebd0efe"
import script from "./DialogPhotoDetail.vue?vue&type=script&lang=js"
export * from "./DialogPhotoDetail.vue?vue&type=script&lang=js"
import style0 from "./DialogPhotoDetail.vue?vue&type=style&index=0&id=aebd0efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports